<!--上传文件过大弹窗-->
<template>
  <Modal
    v-model="modalVisible"
    title="提示"
    :mask-closable="false"
    width="532"
    @on-cancel="closeModal"
  >
    <div class="text-14">
      <p class="mb-1">以下文件大小超过{{ maxSize }}M，请重新制作文件后再次上传</p>
      <p v-for="(item, index) in fileList" :key="index">{{ item }}</p>
    </div>
    <div slot="footer">
      <Button type="primary" size="large" @click="closeModal">
        确认
      </Button>
    </div>
  </Modal>
</template>

<script>
import { Modal, Button } from 'iview';
import { mapState } from 'vuex';

export default {
  name: 'FileOversizeModal',
  components: {
    Modal, Button
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    ...mapState({
      showModal: (state) => state.globalModal.fileOversizeOpt.visible,
      maxSize: (state) => state.globalModal.fileOversizeOpt.maxSize,
      fileList: (state) => state.globalModal.fileOversizeOpt.fileList,
    }),
  },
  watch: {
    showModal(val) {
      this.modalVisible = val;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('globalModal/updateFileOversizeOpt', {
        visible: false,
        fileList: []
      });
    }
  }
};
</script>
